import React, { useEffect, useState, useContext } from 'react'
import { components, constants, useServices, useTranslation } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import ManifestKeys from 'src/constants/locale/key/AciHighwayManifest'
import NaCodeMaintenanceApiURLs from 'src/apiUrls/NaCodeMaintenanceApiUrls'
import BillOfLadingDialog from './BillOfLadingDialog'
import { useFormContext, useWatch } from 'react-hook-form';
import {
  Box,
  Grid,
  InputAdornment,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Tooltip
} from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import { FdaPNTranslationContext } from './../contexts/FDAPNTranslationContext'

const useStyles = makeStyles((theme) => ({
  table: {
    '& .MuiTableHead-root': {
      backgroundColor: theme.palette.background.sectionOddBg,
      '& .MuiTableCell-head': {
        borderBottom: 0,
        fontSize: 12,
        fontWeight: 700,
        lineHeight: 1.2,
        textTransform: 'uppercase'
      }
    },
    '& .MuiTableBody-root': {
      '& .MuiTableRow-root': {
        '&:last-child': {
          '& .MuiTableCell-root': {
            borderBottom: 0
          }
        }
      }
    },
    '& .MuiTableCell-root': {
      padding: '8px 16px'
    }
  }
}))

const {
  button: { CngButton, CngIconButton },
  table: { useFetchCodeMaintenanceLookup },
  form: {
    field: {
      CngCheckboxField,
      CngTextField,
      CngDateField,
      CngTimeField,
      CngCodeMasterAutocompleteField,
      CngCountryAutocompleteField,
      CngSelectField
    },
  },
  CngGridItem,
} = components

const {
  filter: { EQUAL }
} = constants

function BillOfLadingTable(props) {
  const {
    data,
    onAddBOL,
    onDeleteBOL,
    onEditBOL,
    showNotification,
    shouldHideMap,
    disabled
  } = props

  const [lookups, setLookups] = useState(null)
  const [searchTerm, setSearchTerm] = useState('')
  const [bolDTODialog, setBolDTODialog] = useState({
    isView: false,
    open: false,
    bolDTO: null
  })
  const { fetchRecords } = useServices()
  const fetchCodeMaintenanceLookup = useFetchCodeMaintenanceLookup()
  const { translate } = useTranslation(Namespace.ACIHWY_MANIFEST)
  const classes = useStyles()
  const { getTranslatedText } = useContext(FdaPNTranslationContext)
  // const { getValues, setValue, reset, trigger } = useFormContext();

  const filtered =
    searchTerm !== ''
      ? data.filter((bolDTO) =>
        bolDTO.bolNumber
          .toLowerCase()
          .includes(searchTerm.toLowerCase())
      )
      : data

  useEffect(() => {
    Promise.all([
      // Bill Type
      fetchCodeMaintenanceLookup(
        constants.CodeMaintenanceType.CODE_MASTER,
        undefined,
        [{ field: 'codeType', operator: EQUAL, value: 'FDA_PN_BOL_BILL_TYPE' }],
        undefined,
        'code'
      ),
    ]).then(
      ([
        billType,
      ]) => {
        setLookups({
          billType
        })
      }
    )
  }, [])

  function getLookupValue(name, value) {
    if (!lookups) return value

    return lookups[name] && lookups[name][value] ? lookups[name][value] : value
  }

  return (
    <>
      <Box marginBottom={1}>
        <Grid container spacing={2}>
          <Grid item xs>
            {data.length > 0 && (
              <TextField
                fullWidth
                onChange={(event) => setSearchTerm(event.target.value)}
                placeholder='Search in your entries'
                size='small'
                variant='outlined'
                InputProps={{
                  startAdornment: (
                    <InputAdornment position='start'>
                      <FontAwesomeIcon icon={['fal', 'search']} />
                    </InputAdornment>
                  )
                }}
              />
            )}
          </Grid>
          {onAddBOL && (
            <Grid item xs='auto'>
              <CngButton
                color='secondary'
                onClick={() =>
                  setBolDTODialog({
                    open: true,
                    isView: false,
                    bolDTO: null
                  })
                }
                size='medium'
                startIcon={<FontAwesomeIcon icon={['fal', 'plus-circle']} />}
              >
                Add Bill Of Lading
              </CngButton>
            </Grid>
          )}
        </Grid>
      </Box>
      <TableContainer>
        <Table className={clsx(classes.table, 'new-ui-table-component__table')}>
          <TableHead>
            <TableRow>
              <TableCell>{getTranslatedText('FDAPN', 'billType')}</TableCell>
              <TableCell>{getTranslatedText('FDAPN', 'bolIssuerCode')}</TableCell>
              <TableCell>{getTranslatedText('FDAPN', 'bolNumber')}</TableCell>
              {(onEditBOL || onDeleteBOL) && (
                <TableCell align='right'>Action</TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {filtered.length > 0 ? (
              filtered.map((bolDTO) => (
                <TableRow
                  key={Math.random()}
                  onClick={() =>
                    setBolDTODialog({ open: true, isView: true, bolDTO })
                  }
                >
                  <TableCell>{getLookupValue('billType', bolDTO.billType)}</TableCell>
                  <TableCell>{bolDTO.bolIssuerCode}</TableCell>
                  <TableCell>{bolDTO.bolNumber}</TableCell>
                  {(onEditBOL || onDeleteBOL) && (
                    <TableCell align='right'>
                      <Grid container justify='flex-end' spacing={1}>
                        {onEditBOL && (
                          <Grid item xs='auto'>
                            <Tooltip placement='bottom' title='Edit'>
                              <span>
                                <CngIconButton
                                  type='outlined'
                                  icon={['fal', 'pen']}
                                  onClick={(event) => {
                                    event.stopPropagation()
                                    setBolDTODialog({ open: true, isView: false, bolDTO })
                                  }}
                                  size='small'
                                />
                              </span>
                            </Tooltip>
                          </Grid>
                        )}
                        <Grid item xs='auto'>
                          <Tooltip placement='bottom' title='Clone'>
                            <span>
                              <CngIconButton
                                icon={['fal', 'copy']}
                                onClick={(event) => {
                                  event.stopPropagation()
                                  onAddBOL({ ...bolDTO, id: undefined })
                                }}
                                size='small'
                                type='outlined'
                              />
                            </span>
                          </Tooltip>
                        </Grid>
                        {onDeleteBOL && (
                          <Grid item xs='auto'>
                            <Tooltip placement='bottom' title='Delete'>
                              <span>
                                <CngIconButton
                                  type='outlined'
                                  icon={['fal', 'trash']}
                                  onClick={(event) => {
                                    event.stopPropagation()
                                    onDeleteBOL(bolDTO)
                                  }}
                                  size='small'
                                />
                              </span>
                            </Tooltip>
                          </Grid>
                        )}
                      </Grid>
                    </TableCell>
                  )}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  align='center'
                  colSpan={3 + (onEditBOL || onDeleteBOL ? 1 : 0)}
                >
                  <Typography variant='body2' color='textSecondary'>
                    No records to display
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <BillOfLadingDialog
        isView={bolDTODialog.isView}
        open={bolDTODialog.open}
        onClose={() =>
          setBolDTODialog({ open: false, isView: false, bolDTO: null })
        }
        onAddBOLDTO={onAddBOL}
        onEditBOLDTO={onEditBOL}
        showNotification={showNotification}
        bolDTO={bolDTODialog.bolDTO}
        getLookupValue={getLookupValue}
      />
    </>
  )
}

export default BillOfLadingTable
